import {Form, Formik} from "formik";
import NsField from "../../../components/fields/NsField";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import React from "react";

export default function FormModificaGruppoUtente({
                                                     idGruppo,
                                                     formikRef,
                                                     SignupSchema,
                                                     onSubmitFormGruppiUtente,
                                                     initialFormValuesGruppiUtente,
                                                 }) {

    return (
        <Formik
            initialValues={initialFormValuesGruppiUtente}
            innerRef={formikRef}
            validationSchema={SignupSchema}
            onSubmit={onSubmitFormGruppiUtente}
        >
            {({errors, touched, values, submitCount}) => (
                <Form className="row g-3">
                    <div className="col-md-6">
                        <NsField
                            name={"codice"}
                            label={"Codice*:"}
                            isDisabled={idGruppo}
                            formikRef={formikRef}
                            values={values}
                            errors={errors}
                            touched={touched}
                            submitCount={submitCount}
                        />
                    </div>
                    <div className="col-md-6">
                        <NsField
                            name={"descrizione"}
                            label={"Descrizione*:"}
                            formikRef={formikRef}
                            values={values}
                            errors={errors}
                            touched={touched}
                            submitCount={submitCount}
                        />
                    </div>
                    <div className="col-md-12">
                        <NsField
                            name={"note"}
                            label={"Note:"}
                            as={"textarea"}
                            formikRef={formikRef}
                            values={values}
                            errors={errors}
                            touched={touched}
                            submitCount={submitCount}
                        />
                    </div>

                    <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                </Form>
            )}
        </Formik>
    );
}